import { render } from "./EdicionPortalCautivoHotspot.vue?vue&type=template&id=6c08be74&scoped=true"
import script from "./EdicionPortalCautivoHotspot.vue?vue&type=script&lang=js"
export * from "./EdicionPortalCautivoHotspot.vue?vue&type=script&lang=js"

import "./EdicionPortalCautivoHotspot.vue?vue&type=style&index=0&id=6c08be74&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c08be74"]])

export default __exports__